<template>
<div class="chapter">
<div class="inner_page">
<p class="ded2">To Morag, Zac and Albie, for everything</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?693960ac